import React from "react";
import GAGroupDetailsContainer from "../../modules/GAGroups/containers/GAGroupDetailsContainer/GAGroupDetailsContainer";

const GAGroupDetails = () => {
  return <GAGroupDetailsContainer />;
};

export default GAGroupDetails;

